import { Button } from "@/components/molecules/buttons/button";
import useConsultantInvoices from "@/services/admin-services/query/useConsultantInvoices";
import { useParams } from "react-router-dom";
import Invoice from "./Invoice";
import { Label } from "@/components/atoms/texts/label";
import ArrowBack from "@mui/icons-material/ArrowBack";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEffect, useRef, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import Filter from "@/components/organisms/Filter";
import PrintInformationMessage from "@/components/organisms/feedback/PrintInformationMessage";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useDeleteConsultantInvoice } from "@/services/admin-services/mutations/useDeleteConsultantInvoice";
import EditBillsPanel from "@/components/macro-organisms/panels/panels-admin/Bills/EditBillsPanel";
import AddInvoicePanel from "@/components/macro-organisms/panels/panels-admin/Bills/AddInvoicePanel"; import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { useTranslation } from "react-i18next";
import { Toaster } from "@/components/organisms/feedback/toaster";

import MultiSelectorComponent, { ContentType } from "@/components/macro-organisms/tabs/MultiSelectorComponent";


export default function InvoicesTab({ setInvoiceTab, allYears, selectedYearParent, dataOwner }) {
    const { id } = useParams();
    const [t] = useTranslation("global");

    const [selectedClient, setSelectedClient] = useState();
    const [invoicesCopy, setInvoicesCopy] = useState();
    const [selectedYear, setSelectedYear] = useState(selectedYearParent );

    const { invoices, year, loading, error, refetch } = useConsultantInvoices(selectedYear);
    const { deleteConsultantInvoice, loading: loadingDelete, error: errorDelete, data: dataDelete } = useDeleteConsultantInvoice();


    useEffect(() => {

        if (selectedClient) {
            setInvoicesCopy(invoices.filter((item) => {
                console.log("item.clientName", item.clientName, "selectedClient", selectedClient);
                console.log("item.clientName == selectedClient", item.clientName == selectedClient);
                return (item.clientName == selectedClient);

            }));
            console.log("invoicesCopy", invoicesCopy);
        } else {
            setInvoicesCopy(invoices);
        }
    }, [selectedClient, invoices]);

    useEffect(() => {
        refetch();
    }, [dataDelete]);


    useEffect(() => {
        id && setSelectedClient();
    }, [id]);

    useEffect(() => {
        if (!Array.isArray(allYears) || allYears.length === 0) {
            setSelectedYear(null);
            return;
        }

        setSelectedYear((previousYear) => {
            if (previousYear && allYears.includes(previousYear)) return previousYear;
            if (selectedYearParent && allYears.includes(selectedYearParent)) return selectedYearParent;
            return allYears[allYears.length - 1];
        });
    }, [allYears, selectedYearParent]);


    return (
        <div className="flex flex-col  gap-secondDegree overflow-auto pb-secondDegree px-1 items-center">
            <Toaster />
            <div className="flex gap-secondDegree items-center w-full justify-between">
                <Button showLeftIcon leftIcon={<ArrowBack />} text="global.actions.return" onClick={() => setInvoiceTab(false)} style="outline" />
                <div className="grow flex items-center justify-center ml-[8%] gap-firstDegree">
                    <Label size="h4" fontWeight="bold" className="">Détails des factures</Label>
                    <Button style="ghost" disabled={loading} showLeftIcon leftIcon={<ReplayRoundedIcon />} onClick={() => refetch()} showText={false} sizePadding={"firstDegree"} />

                </div>
                <div className="flex gap-firstDegree items-center">
                    {/* <EditBillsPanel changeContent={true} disabledDeletion/> */}
                    {dataOwner && <AddInvoicePanel refetch={refetch} dataOwner={dataOwner} />}


                    {selectedClient && <ClearIcon fontSize="small" onClick={() => setSelectedClient(null)} />}
                    <Select onValueChange={setSelectedClient} value={selectedClient}>
                        <SelectTrigger className="w-[180px] p-firstDegree">
                            <SelectValue placeholder={<Label message="global.actions.filterByClient" />}>
                                <Label>{selectedClient || t("global.actions.filterByClient")}</Label>
                            </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                            {Array.from(new Set(invoices.map((item) => item.clientName))).map((clientName, index) => (
                                <SelectItem key={index} value={clientName}>
                                    <Label>{clientName}</Label>
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

            </div>


            <Filter
                items={allYears && allYears}
                informSelectedItem={setSelectedYear}
                defaultSelectedItem={selectedYear}
            />
            {loading && <span className="loader" />}
            {error && <PrintErrorMessage error={error} />}
            <div className="w-full flex justify-end mb-secondDegree">

            </div>

            {!loadingDelete && invoicesCopy?.map((item, index) => (
                <MultiSelectorComponent
                    key={item.uuid}
                    idOfContent={item.uuid}
                    typeOfContent={ContentType.INVOICE}
                    idConsultant={id}
                >
                    <Invoice key={item.uuid} data={item} deleteConsultantInvoice={deleteConsultantInvoice} dataOwner={true} />

                </MultiSelectorComponent>
            ))}
            {invoicesCopy?.length === 0 &&
                <PrintInformationMessage information={"consultants.statement.invoices.emptyData"} />
            }
            {loadingDelete && <span className="loader" />}




        </div>
    )
}
